import getDomainMapKeyFromPathReduxUtil from 'modules/redux/utils/get-domain-map-key-from-path'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import getEndpointFromDomainMapValueReduxUtil from 'modules/redux/utils/legacy/get-endpoint-from-domain-map-value'

/**
 * Gets the api endpoint from the given instance.
 * @param  {Instance} instance
 * @returns {string}
 */
export default function getEndpointSectionUtil (instance) {
  const path = getPathReduxUtil(instance)
  const domainMapKey = getDomainMapKeyFromPathReduxUtil(path)
  const domainMapValue = getValueReduxUtil(instance, domainMapKey)
  return getEndpointFromDomainMapValueReduxUtil(instance.className, domainMapValue)
}
